export enum CourseInformationTab {
  COURSE_INFORMATION = "course-information",
  ROSTER_MANAGEMENT = "roster-management",
  COMMUNITY = "community",
  DUE_DATE_CONTROLS = "due-date-controls",
  ANNOUNCEMENTS = "announcements",
  COURSE_CATALOG_INFO = "course-catalog-info",
}